import React, { PureComponent } from "react";
import { totalYoyGraphConstruct } from "../../util-functions/util-funtions";
import { valueConverter } from '../../util-functions/util-funtions'
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  YAxis
} from "recharts";
import DATA from "../../assets/data";

const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props;

  return <text x={x-2} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="start">{valueConverter(value)}</text>


}

export default class YOYBarChart extends PureComponent {
  constructor() {
    super();
    this.state = {
      resultSet: [],
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.length !== 0) {
      let res = props.data.length > 0 ? totalYoyGraphConstruct(props.data) : [];
      state.resultSet = res;
    }
    return state;
  }

  renderTooltip(e, data) {
    return data.map((itm, ind) => {
      return (
        Object.keys(itm)[0] === e.label && (
          <div
            key={ind}
            style={{
              height: "50px",
              width: "auto",
              padding: "10px",
              backgroundColor: "white",
            }}
          >
            <span style={{ color: DATA.COLOR[ind] }}>
              {Object.keys(itm)[0]}
              <br />
              {valueConverter(itm[`${Object.keys(itm)}`])}
            </span>
          </div>
        )
      );
    });
  }

  render() {
    let { resultSet } = this.state;
    return (
      <>
        <ResponsiveContainer height='66%' width="109%">
          <BarChart
            width={550}
            height={200}
            data={this.props.data ? resultSet : DATA.data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <YAxis style={{ fontSize: "12px" }} tickLine={false} tickFormatter={tick => { return valueConverter(tick) }} padding={{ top: 25 }}/>
            <XAxis dataKey="name" style={{ fontSize: "12px" }} tickLine={false} />
            <Tooltip content={(e) => this.renderTooltip(e, this.props.data)} />
            <Bar dataKey="value" barSize={20} label={<CustomizedLabel myProps={this.props.data?this.props.data:[]} />}>
              {resultSet.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={DATA.COLOR[index]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        {this.props.data.length > 0 ? (
          <ul
            style={{
              display: "flex",
              listStyle: "none",
              margin: "0px",
              marginBottom: "10px",
            }}
          >
            {this.props.data.map((itm, ind) => {
              return (
                <li
                  key={ind}
                  className="SS-ES-li-2"
                  style={{ textDecoration: "", color: DATA.COLOR[ind] }}
                >
                  <div
                    style={{
                      width: 9,
                      height: 9,
                      float: "left",
                      margin: "5px",
                      backgroundColor: DATA.COLOR[ind],
                    }}
                  ></div>
                  {Object.keys(itm)[0]}
                </li>
              );
            })}
          </ul>
        ) : (
            ""
          )}
      </>
    );
  }
}
